export default {
  WAITING_SHIPMENT_ORDER: {
    label: 'Aguardando Pedido',
    value: 'WAITING_SHIPMENT_ORDER',
  },
  WAITING_FOR_MARGIN_VALIDATION: {
    label: 'Aguardando validação da margem',
    value: 'WAITING_FOR_MARGIN_VALIDATION',
  },
  WAITING_FOR_CONCILIATION: {
    label: 'Aguardando conciliação',
    value: 'WAITING_FOR_CONCILIATION',
  },
  RELEASED_FOR_PRE_INVOICE: {
    label: 'Liberado para pré-fatura',
    value: 'RELEASED_FOR_PRE_INVOICE',
  },
  WAITING_LOGISTIC_PROVIDER_VALIDATION: {
    label: 'Aguardando validação da Transportadora',
    value: 'WAITING_LOGISTIC_PROVIDER_VALIDATION',
  },
  WAITING_RELEASE_FOR_PAYMENT: {
    label: 'Aguardando liberação para pagamento',
    value: 'WAITING_RELEASE_FOR_PAYMENT',
  },
  PAID: {
    value: 'PAID',
    label: 'Pago',
  },
  LOGISTIC_PROVIDER_NOT_VALID: {
    value: 'LOGISTIC_PROVIDER_NOT_VALID',
    label: 'Emissor do documento incorreto',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-generation/enums/EnumStatus.js